var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-modal-dialog',{staticClass:"md-modal-dialog-waiting-dialog",attrs:{"md-close-on-esc":false,"md-click-outside-to-close":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var title = ref.title;
var message = ref.message;
return [_c('md-dialog-title',[_vm._v("\n    "+_vm._s(title)+"\n  ")]),_vm._v(" "),_c('md-dialog-content',[_c('img',{staticClass:"loading-animation",attrs:{"src":_vm.img_src}}),_vm._v(" "),_c('p',[_vm._v(_vm._s(message))])])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }